<template>
  <lot-current-price :lot="lot"
                     :start-price-label="startPriceLabel"
                     :current-price-label="currentPriceLabel"
                     :winning-bid-label="winningBidLabel"/>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: "BiddingCurrentPrice",
  props: {
    startPriceLabel: {
      required: false,
      type: [String, Boolean],
      default() {
        return this.$t('Start Price')
      }
    },
    currentPriceLabel: {
      required: false,
      type: [String, Boolean],
      default() {
        return this.$t('Current Bid')
      }
    },
    winningBidLabel: {
      required: false,
      type: [String, Boolean],
      default() {
        return this.$t('Winning Bid')
      }
    }
  },
  computed: {
    ...mapState({
      lot: state => state.lotObject.data,
    })
  }
}
</script>

<style scoped lang="scss">
@import "../../../bootstrap/import";

.ta-lot-current-price {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .ta-current-price-amount,
  .ta-start-price-amount,
  .ta-winning-bid-amount {
    color: $primary;
    font-weight: bold;
    font-size: $font-size-base;
  }
}
</style>
